<form
	#editForm="ngForm"
	[formReset]="editForm"
	(ngSubmit)="editForm.valid && submit()">
	<div class="modal-header">
		<h4
			class="modal-title"
			*ngIf="!loading">
			{{'labels.' + title | translate}}
		</h4>
		<button
			type="button"
			class="close"
			aria-label="Close"
			(click)="dismiss()">
			<span aria-hidden="true">×</span>
		</button>
	</div>
	<div
		class="modal-body"
		ngbAutofocus>
		<div
			class="row"
			*ngIf="loading">
			<div class="col text-center">
				<app-loader [material]="false"></app-loader>
			</div>
		</div>

		<div
			class="row"
			*ngIf="!loading && building">
			<div class="col-sm-12">
				<div class="row">
					<!-- company -->
					<div class="form-group col-md-4">
						<label for="company">{{ 'labels.company' | translate }}*</label>
						<ng-template [ngIf]="companyid">
							<input
								name="companyinput"
								[placeholder]="selected.company?.name"
								required
								type="text"
								class="form-control"
								id="companyinput"
								disabled>
						</ng-template>
						<ng-template [ngIf]="!companyid">
							<app-entity-autocomplete
								entityName="company"
								entityField="name"
								entityFilterType="like"
								[entitySearch]="search.company"
								name="company"
								[(ngModel)]="selected.company"
								placeholder
								required
								#companyautocomp="ngModel"
								[ngClass]="{'is-invalid': editForm.submitted && companyautocomp.invalid}">
							</app-entity-autocomplete>
							<div
								class="invalid-feedback"
								*ngIf="editForm.submitted && companyautocomp.invalid"
								style="display: block;">
								{{'errors.required' | translate}}
							</div>

						</ng-template>
					</div>
					<!-- name -->
					<div class="form-group col-md-4">
						<label for="cname">{{ 'labels.name' | translate }}*</label>
						<input
							[(ngModel)]="building.name"
							#name="ngModel"
							name="name"
							required
							type="text"
							class="form-control"
							placeholder="{{ 'labels.name' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && name.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && name.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- address -->
					<div class="form-group col-md-4">
						<label>{{'labels.address' | translate}}*</label>
						<input
							type="text"
							class="form-control"
							name="address"
							[(ngModel)]="building.address"
							#address="ngModel"
							required
							[ngClass]="{'is-invalid': editForm.submitted && address.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && address.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- streetno -->
					<div class="form-group col-md-4">
						<label>{{'labels.streetno' | translate}}*</label>
						<input
							type="text"
							class="form-control"
							name="streetno"
							[(ngModel)]="building.streetno"
							#streetno="ngModel"
							required
							[ngClass]="{'is-invalid': editForm.submitted && streetno.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && streetno.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- province -->
					<div class="form-group col-md-4">
						<label>{{'labels.province' | translate}}*</label>
						<input
							[(ngModel)]="building.province"
							#province="ngModel"
							name="province"
							required
							type="text"
							class="form-control"
							placeholder="{{ 'labels.province' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && province.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && province.invalid">
							{{'errors.required' | translate}}
						</div>

					</div>
					<!-- city -->
					<div class="form-group col-md-4">
						<label>{{'labels.comune' | translate}}*</label>
						<input
							[(ngModel)]="building.city"
							#city="ngModel"
							name="city"
							required
							type="text"
							class="form-control"
							placeholder="{{ 'labels.comune' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && city.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && city.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- zipcode -->
					<div class="form-group col-md-4">
						<label>{{'labels.zipcode' | translate}}*</label>
						<input
							type="text"
							class="form-control"
							name="zipcode"
							[(ngModel)]="building.zipcode"
							required
							#zipcode="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && zipcode.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && zipcode.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- buildingtype -->
					<div class="form-group col-md-4">
						<label>{{'labels.buildingtype' | translate}}*</label>
						<select
							class="form-control custom-select"
							[(ngModel)]="building.buildingtype"
							required
							#buildingtype="ngModel"
							name="buildingtype"
							[ngClass]="{'is-invalid': editForm.submitted && buildingtype.invalid}">
							<option
								*ngFor="let bt of buildingtypes"
								[value]="bt.itemvalue">
								{{bt.itemlabel}}
							</option>
						</select>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && buildingtype.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- bondtypes -->
					<div class="form-group col-md-4">
						<label for="company">{{ 'labels.bondtype' | translate }}*</label>
						<select
							class="form-control custom-select"
							[(ngModel)]="building.bondtype"
							required
							#bondtype="ngModel"
							name="bondtype"
							[ngClass]="{'is-invalid': editForm.submitted && bondtype.invalid}">
							<option
								*ngFor="let type of bondtypes"
								[value]="type">
								{{ 'labels.' + type | translate}}
							</option>
						</select>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && bondtype.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- value -->
					<div
						*ngIf="building.isPurchase"
						class="form-group col-md-4">
						<label>{{'labels.value' | translate}}*</label>
						<input
							type="number"
							class="form-control"
							name="value"
							[(ngModel)]="building.value"
							required
							#value="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && value.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && value.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- depreciationstart -->
					<div
						*ngIf="building.isPurchase"
						class="form-group col-md-4">
						<label>
							{{'labels.depreciationstart' | translate}}*
						</label>
						<app-datepicker
							[(ngModel)]="building.depreciationstart"
							name="depreciationstart"
							required
							#depreciationstart="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && depreciationstart.invalid}">
						</app-datepicker>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && depreciationstart.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- depreciationend -->
					<div
						*ngIf="building.isPurchase"
						class="form-group col-md-4">
						<label>
							{{'labels.depreciationend' | translate}}*
						</label>
						<app-datepicker
							[(ngModel)]="building.depreciationend"
							name="depreciationend"
							required
							#depreciationend="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && depreciationend.invalid}">
						</app-datepicker>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && depreciationend.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- leasingfee -->
					<div
						*ngIf="building.isLeasing"
						class="form-group col-md-4">
						<label>{{'labels.leasingfee' | translate}}*</label>
						<input
							type="number"
							class="form-control"
							name="leasingfee"
							[(ngModel)]="building.leasingfee"
							required
							#leasingfee="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && leasingfee.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && leasingfee.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
	<div class="modal-footer">

		<button
			type="reset"
			class="btn btn-secondary">
			{{'labels.reset' | translate}}
		</button>
		<button
			type="button"
			class="btn btn-secondary"
			(click)="dismiss()">
			{{'labels.cancel' | translate}}
		</button>
		<button
			type="submit"
			class="btn btn-primary">
			{{'labels.save' | translate}}
		</button>
	</div>
</form>
